export const sortedList = [
  'visits',
  'visitors',
  'contributions',
  'contributors',
]

export const sortedActivityKeys: any = (keys: { keys: string }[]) =>
  keys.sort(
    (a: any, b: any) => sortedList.indexOf(a.key) - sortedList.indexOf(b.key),
  )
